import React from 'react'
import { Link } from 'react-router-dom'

function Footer() {
  return (
    <div className="footer_home">
      <div className="container">
        <div className="row">
          <div className="col-md-6 text-center text-lg-left">
            <a href ="/carter/feedback" className="first">Feedback</a>
            <a href ="/carter/privacypolicy">Privacy Policy</a>
            <a href ="/carter/terms">Terms of Use</a>
          </div>
          <div className="col-md-6">
            <span className="copyright">Open Play Tennis Copyright  <span className="copyRtText"> &copy; </span>  2025. All rights reserved</span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Footer